<script lang='ts'>
import { defineComponent, watch, SetupContext, onMounted, onUnmounted } from '@vue/composition-api';
import { isObject } from 'lodash';
import { oauthProviders, oauthProviderSettings, OauthProvider, snackbar } from './use';

interface IProps {
    isOpen: boolean;
    oauthProvider: oauthProviders;
    storymapId?: string;
    title?: string;
    width?: number;
}

interface IOauthCallbackResponse {
    oauthProvider: number;
    isSuccess: boolean;
    message: string;
}

let shouldEmitCloseEvent = true;

const openOauthExternalWindow = (oauthProvider: OauthProvider, ctx: SetupContext, storymapId?: string) => {
    const title = `${oauthProvider.name} Oauth activation`;
    const w = 700;
    const h = 720;
    const left = screen.width / 2 - w / 2;
    const top = screen.height / 2 - h / 2;
    const url = storymapId != null ? oauthProvider.oauthUrl + '&storymapId=' + storymapId : oauthProvider.oauthUrl;
    const oauthWindow = window.open(
        url,
        title,
        'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no,width=' +
            w +
            ',height=' +
            h +
            ',top=' +
            top +
            ',left=' +
            left
    );

    const timer = setInterval(checkChild, 500);
    function checkChild() {
        if (!oauthWindow) {
            snackbar.showWarning('Please enable popup windows in your browser to setup oauth.');
            clearInterval(timer);
        }

        if (oauthWindow && oauthWindow.closed) {
            clearInterval(timer);
            close(ctx);
        }
    }
};

const close = (ctx: SetupContext) => {
    if (shouldEmitCloseEvent) {
        ctx.emit('close');
    }
};

const AppOauthDialog = defineComponent<IProps>({
    name: 'AppOauthDialog',
    props: {
        isOpen: Boolean,
        oauthProvider: Number,
        storymapId: String,
        title: String,
        width: Number,
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        const oauthProvider = oauthProviderSettings.get(props.oauthProvider);

        watch(
            () => props.isOpen,
            () => {
                if (props.isOpen) {
                    openOauthExternalWindow(oauthProvider, ctx, props.storymapId);
                }
            },
            { immediate: true }
        );

        const reciveFromPostMessage = (event: MessageEvent): void => {
            if (
                !isObject(event.data.response) ||
                (event.data.response.oauthProvider !== oauthProvider.name && event.data.response.oauthProvider !== oauthProvider.enumValue)
            ) {
                return;
            }

            const { response } = event.data;

            shouldEmitCloseEvent = false;
            if (response.isSuccess) {
                ctx.emit('success', response.message);
            } else {
                ctx.emit('error', response.message);
            }
        };

        onMounted(() => {
            window.addEventListener('message', reciveFromPostMessage, false);
        });

        onUnmounted(() => {
            window.removeEventListener('message', reciveFromPostMessage);
        });

        return {};
    },
});

export default AppOauthDialog;
</script>

<template>
  <div class="dialog" />
</template>

<style lang='scss' scoped>
.v-dialog__content {
    opacity: 0;
}
</style>